// import React, { useState } from "react";
// import { GridColDef } from "@mui/x-data-grid";
// import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
// import { callAPI, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
// import dayjs from "dayjs";

// export const WorkOrderReport: React.FC = () => {
//   const [rows, setRows] = useState<any[]>([]);

//   const workOrderColumns: GridColDef[] = [
//     { field: "date", headerName: "Date", flex: 1 },
//     { field: "workOrderCount", headerName: "Work Order Count", flex: 1 },
//     { field: "totalItems", headerName: "Total Items", flex: 1 },
//     { field: "totalQuantity", headerName: "Total Quantity", flex: 1 },
//     { field: "totalAmount", headerName: "Total Amount", flex: 1 },
//   ];

//   const handleApply = async (payload: any) => {
//     try {
//       const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
//       const toDate = dayjs(payload.toDate).format("YYYY/MM/DD");

//       const userId = localStorage.getItem(LoacalVariables.UserId);
//       if (!userId) {
//         alert("UserId not found. Please login again.");
//         return;
//       }

//       console.log("Using userId:", userId);

//       const query = `?fromDate=${fromDate}&toDate=${toDate}&userId=${userId}`;
//       console.log("the reponse is",query)

//       const response = await callAPI(
//         `FinancialReport/workorder-report${query}`,
//         Method.GET
//       );

//       console.log("API Response:", response);

//       // Map rows with unique id for DataGrid
//       setRows(
//         (response?.data?.report || []).map((row: any, index: number) => ({
//           ...row,
//           id: index,
//         }))
//       );
//     } catch (err) {
//       console.log("Error fetching WorkOrder Report", err);
//     }
//   };

//   return (
//     <ReportBaseTemplate
//       title="WorkOrder Report"
//       columns={workOrderColumns}
//       rows={rows}
//       onApply={handleApply}
//     />
//   );
// };

// export default WorkOrderReport;





// import React, { useState } from "react";
// import { 
//   GridColDef, 
//   GridRenderCellParams
// } from "@mui/x-data-grid";
// import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
// import { callAPI, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
// import dayjs from "dayjs";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   Typography,
// } from "@mui/material";

// interface Item {
//   itemName: string;
//   quantity: number;
//   unitPrice: number;
//   amount: number;
// }

// interface WorkOrder {
//   id: string;
//   workOrderId: string;
//   customerName: string;
//   date: string;
//   approximateArea: string;
//   totalItems: number;
//   totalQuantity: number;
//   totalAmount: number;
//   items: Item[];
// }

// export const WorkOrderReport: React.FC = () => {
//   const [rows, setRows] = useState<WorkOrder[]>([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [selectedWorkOrder, setSelectedWorkOrder] = useState<WorkOrder | null>(null);

  

//  const workOrderColumns: GridColDef[] = [
//   { 
//     field: "date", 
//     headerName: "Date", 
//     flex: 1,
//     renderCell: (params: any) => {
//       const dateValue = params.row.date;
//       return dateValue ? dayjs(dateValue).format("DD/MM/YYYY") : '';
//     }
//   },
//   { 
//     field: "customerName", 
//     headerName: "Customer", 
//     flex: 1.2 
//   },
//   { 
//     field: "approximateArea", 
//     headerName: "Area", 
//     flex: 0.8 
//   },
//   { 
//     field: "totalItems", 
//     headerName: "Items", 
//     flex: 0.8 
//   },
//   { 
//     field: "totalQuantity", 
//     headerName: "Quantity", 
//     flex: 1 
//   },
//   { 
//     field: "totalAmount", 
//     headerName: "Amount", 
//     flex: 1,
//     renderCell: (params: any) => {
//       const amount = params.row.totalAmount;
//       return amount ? `₹${amount.toLocaleString()}` : '₹0';
//     }
//   },
//   {
//     field: "actions",
//     headerName: "Actions",
//     flex: 0.8,
//     sortable: false,
//     renderCell: (params: GridRenderCellParams<WorkOrder>) => (
//       <Button
//         size="small"
//         variant="outlined"
//         onClick={() => handleViewDetails(params.row)}
//       >
//         Details
//       </Button>
//     ),
//   },
// ];





//   const handleApply = async (payload: any) => {
//   try {
//     const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
//     const toDate = dayjs(payload.to).format("YYYY-MM-DD");

//     const userId = localStorage.getItem(LoacalVariables.UserId);
//     if (!userId) {
//       alert("UserId not found. Please login again.");
//       return;
//     }

//     console.log("Using userId:", userId);
//     console.log("Date range:", { fromDate, toDate });

//     const query = `?fromDate=${fromDate}&toDate=${toDate}&userId=${userId}`;
//     const response = await callAPI(
//       `FinancialReport/workorder-report/detailed${query}`,
//       Method.GET
//     );

//     console.log("API Response:", response);

//     // ✅ FIXED: Use response?.data (not response?.data?.data)
//     setRows((response?.data || []).map((workOrder: any, index: number) => ({
//       ...workOrder,
//       id: workOrder.workOrderId || `row-${index}`,
//     })));

//     console.log("Mapped rows:", (response?.data || []).length); // Debug log

//   } catch (err: any) {
//     console.error("Error fetching WorkOrder Report:", err);
//     setRows([]);
//   }
// };



//   const handleViewDetails = (workOrder: WorkOrder) => {
//     setSelectedWorkOrder(workOrder);
//     setOpenModal(true);
//   };

//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setSelectedWorkOrder(null);
//   };

//   return (
//     <>
//      return (
//   <>
//     <ReportBaseTemplate
//       title="WorkOrder Report"
//       columns={workOrderColumns}
//       rows={rows}
//       onApply={handleApply}
//       showDownload={true}  // 👈 DISABLE DOWNLOAD
//     />

//     {/* Modal code remains unchanged */}
//   </>
// );


//       {/* WorkOrder Details Modal */}
//       <Dialog open={openModal} onClose={handleCloseModal} maxWidth="lg" fullWidth>
//         <DialogTitle>
//           Work Order Details
//           {selectedWorkOrder && (
//             <Typography variant="h6" component="span" sx={{ ml: 2 }}>
//               - {selectedWorkOrder.customerName} (₹{selectedWorkOrder.totalAmount.toLocaleString()})
//             </Typography>
//           )}
//         </DialogTitle>
//         <DialogContent sx={{ minHeight: 400 }}>
//           {selectedWorkOrder ? (
//             <>
//               <TableContainer component={Paper} sx={{ mt: 2 }}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       {/* <TableCell>Work Order ID</TableCell> */}
//                       <TableCell>Customer</TableCell>
//                       <TableCell>Date</TableCell>
//                       <TableCell align="right">Area</TableCell>
//                       <TableCell align="right">Items</TableCell>
//                       <TableCell align="right">Quantity</TableCell>
//                       <TableCell align="right">Total Amount</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     <TableRow>                                                                                        
//                       {/* <TableCell sx={{ fontSize: '0.875rem', fontFamily: 'monospace' }}>
//                         {selectedWorkOrder.workOrderId.slice(-8)}...
//                       </TableCell> */}
//                       <TableCell>{selectedWorkOrder.customerName}</TableCell>
//                       <TableCell>{dayjs(selectedWorkOrder.date).format("DD/MM/YYYY")}</TableCell>
//                       <TableCell align="right">{selectedWorkOrder.approximateArea}</TableCell>
//                       <TableCell align="right">{selectedWorkOrder.totalItems}</TableCell>
//                       <TableCell align="right">{selectedWorkOrder.totalQuantity.toLocaleString()}</TableCell>
//                       <TableCell align="right">
//                         ₹{selectedWorkOrder.totalAmount.toLocaleString()}
//                       </TableCell>
//                     </TableRow>
//                   </TableBody>
//                 </Table>
//               </TableContainer>

//               {/* Items Breakdown */}
//               <TableContainer component={Paper} sx={{ mt: 3 }}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>Item Name</TableCell>
//                       <TableCell align="right">Quantity</TableCell>
//                       <TableCell align="right">Unit Price</TableCell>
//                       <TableCell align="right">Amount</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {selectedWorkOrder.items.map((item, index) => (
//                       <TableRow key={index}>
//                         <TableCell>{item.itemName}</TableCell>
//                         <TableCell align="right">{item.quantity.toLocaleString()}</TableCell>
//                         <TableCell align="right">₹{item.unitPrice.toLocaleString()}</TableCell>
//                         <TableCell align="right">₹{item.amount.toLocaleString()}</TableCell>
//                       </TableRow>
//                     ))}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </>
//           ) : (
//             <Typography>No work order details available.</Typography>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseModal} variant="contained">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default WorkOrderReport;




import React, { useState } from "react";
import { 
  GridColDef, 
  GridRenderCellParams
} from "@mui/x-data-grid";
import { ReportBaseTemplate } from "../../Components/ReportBaseTemplate";
import { callAPI, LoacalVariables, Method } from "../../commonFunctions/CommonFunctions";
import dayjs from "dayjs";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';

import config from "../../Config/config.json"; 

interface Item {
  itemName: string;
  quantity: number;
  unitPrice: number;
  amount: number;
}

interface WorkOrder {
  id: string;
  workOrderId: string;
  customerName: string;
  date: string;
  approximateArea: string;
  totalItems: number;
  totalQuantity: number;
  totalAmount: number;
  items: Item[];
}

export const WorkOrderReport: React.FC = () => {
  const [rows, setRows] = useState<WorkOrder[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedWorkOrder, setSelectedWorkOrder] = useState<WorkOrder | null>(null);
  const [lastFilterPayload, setLastFilterPayload] = useState<any>(null);

  const workOrderColumns: GridColDef[] = [
    { 
      field: "date", 
      headerName: "Date", 
      flex: 1,
      renderCell: (params: any) => {
        const dateValue = params.row.date;
        return dateValue ? dayjs(dateValue).format("DD/MM/YYYY") : '';
      }
    },
    { 
      field: "customerName", 
      headerName: "Customer", 
      flex: 1.2 
    },
    { 
      field: "approximateArea", 
      headerName: "Area", 
      flex: 0.8 
    },
    { 
      field: "totalItems", 
      headerName: "Items", 
      flex: 0.8 
    },
    { 
      field: "totalQuantity", 
      headerName: "Quantity", 
      flex: 1 
    },
    { 
      field: "totalAmount", 
      headerName: "Amount", 
      flex: 1,
      renderCell: (params: any) => {
        const amount = params.row.totalAmount;
        return amount ? `₹${amount.toLocaleString()}` : '₹0';
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.8,
      sortable: false,
      renderCell: (params: GridRenderCellParams<WorkOrder>) => (
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleViewDetails(params.row)}
        >
          Details
        </Button>
      ),
    },
  ];

  const handleApply = async (payload: any) => {
    try {
      setLastFilterPayload(payload);
      
      const fromDate = dayjs(payload.fromDate).format("YYYY-MM-DD");
      const toDate = dayjs(payload.to).format("YYYY-MM-DD");

      const userId = localStorage.getItem(LoacalVariables.UserId);
      if (!userId) {
        alert("UserId not found. Please login again.");
        return;
      }

      const query = `?fromDate=${fromDate}&toDate=${toDate}&userId=${userId}`;
      const response = await callAPI(
        `FinancialReport/workorder-report/detailed${query}`,
        Method.GET
      );

      setRows((response?.data || []).map((workOrder: any, index: number) => ({
        ...workOrder,
        id: workOrder.workOrderId || `row-${index}`,
      })));
    } catch (err: any) {
      console.error("Error fetching WorkOrder Report:", err);
      setRows([]);
    }
  };

const handleDownloadExcel = async () => {
  const userId = localStorage.getItem(LoacalVariables.UserId);
  if (!userId || !lastFilterPayload) {
    alert("Please apply filters first.");
    return;
  }

  const fromDate = dayjs(lastFilterPayload.fromDate).format("YYYY-MM-DD");
  const toDate = dayjs(lastFilterPayload.to).format("YYYY-MM-DD");
  
  // ✅ Build URL using your config - NO HARDCODING
  const url = `${config.apiBaseUrl}FinancialReport/workorder-report/detailed/excel?fromDate=${fromDate}&toDate=${toDate}&userId=${userId}`;
  
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });

    if (!response.ok) throw new Error('Download failed');

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    
    const filename = `WorkOrder_Report_${fromDate}_to_${toDate}.xlsx`;
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
    
  } catch (error) {
    console.error("Download error:", error);
    alert("Download failed. Please try again.");
  }
};




  const handleViewDetails = (workOrder: WorkOrder) => {
    setSelectedWorkOrder(workOrder);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedWorkOrder(null);
  };

  return (
    <div style={{ position: 'relative' }}>
      {/* ✅ WRAPPER with relative positioning */}
      
      <ReportBaseTemplate
        title="WorkOrder Report"
        columns={workOrderColumns}
        rows={rows}
        onApply={handleApply}
        showDownload={false}
      />

      {/* ✅ SMALL ICON RIGHT TO APPLY FILTER BUTTON */}
      {rows.length > 0 && (
        <div style={{ 
          position: 'absolute',
          top: '35px',    // 👈 Adjust based on your filter bar height
          right: '40px',  // 👈 Right side next to Apply button
          zIndex: 1300 
        }}>
          
  <DownloadIcon sx={{ fontSize: '25px' }} onClick={handleDownloadExcel}/>

        </div>
      )}

      {/* WorkOrder Details Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="lg" fullWidth>
        <DialogTitle>
          Work Order Details
          {selectedWorkOrder && (
            <Typography variant="h6" component="span" sx={{ ml: 2 }}>
              - {selectedWorkOrder.customerName} (₹{selectedWorkOrder.totalAmount.toLocaleString()})
            </Typography>
          )}
        </DialogTitle>
        <DialogContent sx={{ minHeight: 400 }}>
          {selectedWorkOrder ? (
            <>
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Customer</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell align="right">Area</TableCell>
                      <TableCell align="right">Items</TableCell>
                      <TableCell align="right">Quantity</TableCell>
                      <TableCell align="right">Total Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell>{selectedWorkOrder.customerName}</TableCell>
                      <TableCell>{dayjs(selectedWorkOrder.date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell align="right">{selectedWorkOrder.approximateArea}</TableCell>
                      <TableCell align="right">{selectedWorkOrder.totalItems}</TableCell>
                      <TableCell align="right">{selectedWorkOrder.totalQuantity.toLocaleString()}</TableCell>
                      <TableCell align="right">₹{selectedWorkOrder.totalAmount.toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <TableContainer component={Paper} sx={{ mt: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Item Name</TableCell>
                      <TableCell align="right">Quantity</TableCell>
                      <TableCell align="right">Unit Price</TableCell>
                      <TableCell align="right">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedWorkOrder.items.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.itemName}</TableCell>
                        <TableCell align="right">{item.quantity.toLocaleString()}</TableCell>
                        <TableCell align="right">₹{item.unitPrice.toLocaleString()}</TableCell>
                        <TableCell align="right">₹{item.amount.toLocaleString()}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <Typography>No work order details available.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default WorkOrderReport;
